<template>
  <div v-if="quote" class="card border-md-none order-summary">
    <div class="card-body py-6 px-md-9 pb-0">
      <div>
        <!-- Todo: make this a reusable component because it's used within Pricing -->
        <div class="d-flex flex-wrap">
          <h5 class="mb-6 mr-3" v-dynamic-content:pv_content_title="[$options.filters.formatKwh(quote.detailOverview.energyGenerated[0])]"></h5>
          <router-link
            :to="{ name: 'ContentProposal' }"
            class="edit-link text-muted font-size-sm font-weight-normal"
            v-if="!done"
          >
            {{ content.general_edit }}
          </router-link>
        </div>
        <ul v-if="!isGeneric" class="checks list-unstyled mx-auto mb-0">
          <IconList :items="pvItemsList" :type="'checks'" />
          <!-- <li
            v-if="content.pv_content_panels"
            v-dynamic-content:pv_content_panels="[
              quote.panels.quantity,
              pickProductName(quote.panels),
            ]"
          ></li> -->
          <!-- <template v-if="quote.batteries">
            <li v-for="(battery, index) in quote.batteries" :key="index">
              <span
                v-dynamic-content:pv_content_battery="[battery.quantity, pickProductName(battery)]"
              ></span>
            </li>
          </template> -->
          <!-- <li>
            <span
              v-if="countInverters(quote.inverters) === 1 && quote.inverters[0].quantity === 1"
              v-dynamic-content:pv_content_inverter1="[
                quote.inverters[0].quantity,
                pickProductName(quote.inverters[0]),
              ]"
            ></span>
            <span
              v-if="countInverters(quote.inverters) === 1 && quote.inverters[0].quantity > 1"
              v-dynamic-content:pv_content_inverter_multiple2="[
                quote.inverters[0].quantity,
                pickProductName(quote.inverters[0]),
              ]"
            ></span>
            <span
              v-if="countInverters(quote.inverters) === 2"
              v-dynamic-content:pv_content_inverter_multiple3="[
                quote.inverters[0].quantity,
                pickProductName(quote.inverters[0]),
                quote.inverters[1].quantity,
                pickProductName(quote.inverters[1]),
              ]"
            ></span>
            <span
              v-if="countInverters(quote.inverters) === 3"
              v-dynamic-content:pv_content_inverter_multiple4="[
                quote.inverters[0].quantity,
                pickProductName(quote.inverters[0]),
                quote.inverters[1].quantity,
                pickProductName(quote.inverters[1]),
                quote.inverters[2].quantity,
                pickProductName(quote.inverters[2]),
              ]"
            ></span>
          </li> -->
          <!-- <template v-if="content.pv_content_optimizer && showAdders"> 
            <li v-for="(adder, index) in quote.adders" :key="index + 'i'" v-dynamic-content:pv_content_optimizer="[adder.quantity, pickProductName(adder)]">
            </li>
          </template> -->
          <li v-if="content.pv_content_arei" v-dynamic-content:pv_content_arei></li>
          <li
            v-if="content.pv_production_meter && quote.hasSunsure"
            v-dynamic-content:pv_production_meter
          ></li>

          <li v-if="content.pv_content_assembly" v-dynamic-content:pv_content_assembly></li>
          <li v-if="content.grid_connection" v-dynamic-content:grid_connection></li>
          <li
            v-if="content.extra_power_group_if_necessary"
            v-dynamic-content:extra_power_group_if_necessary
          ></li>
          
          <li v-for="(environmentalContribution, index) in quote.environmentalContribution" :key="index+'e'">
            <span>{{ pickProductName(environmentalContribution) }} </span>
          </li>
          <li v-if="content.pv_content_installation">
            <span v-dynamic-content:pv_content_installation></span>
            <p
              class="mb-0 font-size-sm text-muted"
              v-dynamic-content:pv_content_installation_subtext
            ></p>
          </li>

          <li
            v-if="content.summary_content_warrantees"
            v-dynamic-content:summary_content_warrantees
          ></li>
          <template v-if="showNoSunSure">
            <li class="cross">
              <span v-dynamic-content:pv_sunsure_and_production_meter></span>
            </li>
            <li class="cross">
              <span v-dynamic-content:pv_my_sungevity_yearly_production></span>
            </li>
          </template>
        </ul>
        <ul v-else>
          <IconList :items="genericListItems" :type="'checks'" />
        </ul>
      </div>
    </div>
    <div class="list-group list-group-flush">
      <!-- product services checkboxes & total price -->
      <order-summary-pricing
        :quote="quote"
        :done="done"
        :productsServices="productsServices"
        :showProductsServices="showProductsServices"
      ></order-summary-pricing>
    </div>
  </div>
</template>

<script>
import OrderSummaryPricing from '@/components/order/OrderSummaryPricing'
import IconList from '@/components/main/icon-list/IconList'
import { mapGetters } from 'vuex'

export default {
  name: 'OrderSummaryCard',
  props: ['quote', 'done', 'productsServices', 'showProductsServices'],
  mixins: ['pickProductName'],
  components: {
    OrderSummaryPricing,
    IconList,
  },
  computed: {
    ...mapGetters(['isBelgium', 'locale', 'isGeneric', 'isIChoosr']),
    showNoSunSure() {
      return !this.quote.hasSunsure && this.$store.getters.isNetherlands && !this.isIChoosr
    },
    showAdders() {
      return !this.isIChoosr
    },
    pvItemsList() {
      const items = this.quote.items.map(i => ({ name: `${i.quantity}x  ${this.pickProductName(i)}`, order: i.order })).sort((a,b) => a.order - b.order)
      return items.map(i => i.name)
    },
   
    genericListItems() {
      const products = this.quote.items.map((i) => `${i.quantity}x  ${this.pickProductName(i)}`)
      return products.concat([
        this.content.generic_sungevity_usps_advice,
        this.content.generic_sungevity_usps_installation,
        this.content.generic_sungevity_usps_waranty,
      ])
    },
  },
  methods: {
    countInverters(obj) {
      return Object.keys(obj).length
    },
  },
}
</script>
